import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import Button from "../../common/Button";
import { message } from "antd";
import { useInitiateCheckoutToFundWallet } from "../../hooks/useUserWallet";
import { UserWalletContext } from "../../context/userWalletContext";

const RechargeWallet = ({ order }) => {
  const [price, setPrice] = useState(0);
  const { walletDetails } = useContext(UserWalletContext);
  const prices = [5, 10, 50, 100, 500, 1000];
  useEffect(() => {
    if (order) {
      setPrice(order?.orderAmount);
    }
  }, [order]);
  const onSuccess = (res) => {
    if (res.status === 200) {
      const result = res.data;
      if (result?.url) {
        window.open(result.url, "_top");
      }
    }
  };

  const onError = (err) => {
    message.error(err);
  };

  const { mutate: initiateCheckoutToFundWallet } =
    useInitiateCheckoutToFundWallet(onSuccess, onError);

  const handleSubmit = (e) => {
    e.preventDefault();
    const numericValue = parseFloat(price);
    if (isNaN(numericValue)) {
      message.error("Please enter a valid number.");
      return;
    }
    if (numericValue < 5) {
      message.error("Minimum value is $5.");
      return;
    }
    if (numericValue > 50000) {
      message.error("Maximum value is $50,000.");
      return;
    }
    let payload = {
      amount: numericValue,
      mode: window.location.host === "localhost:3000" ? "test" : "live",
      batch: order?.batchId || null,
      host: `${window.location.protocol}//${window.location.host}`,
    };

    initiateCheckoutToFundWallet(payload);
  };

  const getAmountInputSection = () => {
    return (
      <div className="amount_input_section">
        <h2 className="amount_head">Enter Amount ($)</h2>
        <div className="input_wrapper">
          <div className="input">
            <input
              type="text"
              placeholder=""
              value={price}
              className="input_form"
              onChange={(e) => setPrice(e.target.value)}
            />
            {price?.length > 0 && (
              <div className="cross" onClick={() => setPrice("")}>
                x
              </div>
            )}
          </div>
          <span>Min value: $5 & Max value: $50,0000</span>
        </div>
        <div className="options">
          <h2 className="option_head">Or Select From Below</h2>
          <div className="pricing">
            {prices.length > 0 &&
              prices?.map((item) => {
                return (
                  <button
                    className="item"
                    onClick={() => {
                      setPrice(item);
                    }}
                  >
                    ${item}
                  </button>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  const getWalletSummary = () => {
    return (
      <div className="wallet_summary">
        <div className="amount_field">
          <h2 className="title">
            Current Balance{" "}
            <span>${walletDetails?.availableBalance?.unitAmount}</span>
          </h2>
        </div>
        <div className="amount_field">
          <h2 className="title">
            Recharge Amount <span>${price}</span>
          </h2>
          {order && (
            <h2 className="title">
              Order Amount <span>${order?.orderAmount}</span>
            </h2>
          )}
          <h2 className="title">
            Total Wallet Amount After Recharge{" "}
            <span>
              $
              {(
                Number(price) +
                Number(walletDetails?.availableBalance?.unitAmount) -
                Number(order?.orderAmount || 0)
              ).toFixed(2)}
            </span>
          </h2>
        </div>
        <div className="amount_field">
          <h2 className="title bold">
            To Pay <span>${price}</span>
          </h2>
        </div>
      </div>
    );
  };

  return (
    <div className="recharge_wallet">
      <div className="wallet_header">
        <h2 className="wallet_title">Recharge Your Wallet</h2>
        <h3 className="amount">
          Current Wallet Amount{" "}
          <span>${walletDetails?.availableBalance?.unitAmount}</span>
        </h3>
      </div>
      {getAmountInputSection()}
      {getWalletSummary()}
      <div className="action_btn">
        <Button
          width="100%"
          height="39px"
          text={"Continue to Payment"}
          isDisabled={!price || price < 5 || price > 50000}
          handleClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default RechargeWallet;
